import { render, staticRenderFns } from "./initializeCommunityManageList.vue?vue&type=template&id=242011fa&scoped=true"
import script from "./initializeCommunityManageList.vue?vue&type=script&lang=js"
export * from "./initializeCommunityManageList.vue?vue&type=script&lang=js"
import style0 from "./initializeCommunityManageList.vue?vue&type=style&index=0&id=242011fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242011fa",
  null
  
)

export default component.exports